const getDefaultOptions = () => ({
  orderParams: null,
  billing: null,
  addressId: null,
  channel: null,
  tipAmount: null,
  itemsPrice: null,
  amountToPay: null,
  storeId: null,
  menuId: null,
  deliveryType: null,
  dropOffType: null,
  time: null,
  paymentType: null,
  couponCode: null,
  tableName: null,
  cashAmount: null,
  cardId: null,
  otherPaymentType: null,
  skipPhoneValidation: true,
  sessionEmail: null,
  sessionPhone: null,
  chatCommerceType: null
})

export default getDefaultOptions
